__turbopack_context__.v({
  "checkboxlabel": "ueYYIW_checkboxlabel",
  "checkboxwrapper": "ueYYIW_checkboxwrapper",
  "checkmark": "ueYYIW_checkmark",
  "input": "ueYYIW_input",
  "wrapper": "ueYYIW_wrapper",
});
